import React, { useEffect, useState } from "react";
import { useForm, Controller, reset } from "react-hook-form";
import Header from "../Header";
import MenuBar from "../MenuBar";
import "../userProfile/userProfile.css";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Footer from "../Footer";
import { useAuth } from "../../context/API_Client";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { blue } from "@mui/material/colors";
import { Padding, Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import phonevalidator from "../utils/phoneValidation";

function UserProfile() {
  const { uploadPaymentFormData, getAllModalData } = useAuth();
  const [responseData, setResponseData] = useState([]);
  const [paymentError, setPaymentError] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [password, setPassword] = useState("jone123");
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [fullname, setfullname] = useState("Jone");

  const [dropdownContent, setDropdownContent] =
    React.useState("IST (UTC + 5:30)");

  const handleChange = (event) => {
    const value = event.target.value;
    setDropdownContent(value);
    // handleDropdownChange(value);
  };

  const schema = yup.object({
    paymentLink: yup.string().required("Please enter title of payment link"),
    amount: yup.string().required("Please enter the valid amount"),
    mobileNumber: yup
      .string()
      .required("Mobile number is required")
      .test(
        "is-valid-mobile",
        "Please enter 10 digit mobile number",
        (value) => {
          const regex = /^(\+\d{1,3}[- ]?)?\d{12}$/;
          return regex.test(value);
        }
      )
      .typeError("Mobile number must be a valid number"),
    emailAddress: yup.string().email("Please enter a valid email address"),
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    if (event) {
      event.preventDefault();
    }
  };

  const { handleSubmit, control, formState, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.location.href = "/paymentLinks";
  };

  const [countryLetter, setCountryLetter] = useState("IN");
  const [errorMsg, setErrorMsg] = useState("");
  const handleCountryChange = (value, country) => {
    setCountryLetter(country);
  };

  const handlePhoneChange = (value) => {
    const validationError = phonevalidator(value, countryLetter);

    if (validationError) {
      formState.errors.mobileNumber = { message: validationError };
      setErrorMsg(validationError);
    } else {
      formState.errors.mobileNumber = undefined;
      setErrorMsg("");
    }
  };

  const [notifyViaEmail, setNotifyViaEmail] = useState(false);

  useEffect(() => {
    getAllModalData(
      function (data) {
        setCurrency(data.currencyCodes);
      },
      function (errorMsg) { }
    );
  }, []);

  const onSubmit = (formData, event) => {
    if (event) {
      event.preventDefault();
    }
    uploadPaymentFormData(
      {
        title: formData.paymentLink,
        description: formData.description,
        paymentContext: {
          countryCode: "IN",
          legalEntity: {
            code: "legal_entity",
          },
          orderId: "test12",
          localCode: "fr-FR",
        },
        paymentType: "A",
        money: {
          amount: formData.amount,
          currencyCode: "INR",
        },
        shopper: {
          uniqueReference: formData.mobileNumber,
          email: formData.emailAddress,
          phoneNumber: formData.mobileNumber,
        },
        statusNotifyUrl: "https://www.boxpay.tech",
        notifyViaEmail: notifyViaEmail,
      },
      function (responseData) {
        setResponseData(responseData);
        // if (responseData.length > 0) {
        setNotifyViaEmail(false);
        setValue("paymentLink", "");
        setValue("amount", "");
        setValue("description", "");
        setValue("mobileNumber", "");
        setValue("emailAddress", "");
        handleOpen();
        // }
      },

      function (errorMsg) {
        setPaymentError(errorMsg);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content" style={{ marginTop: "32px" }}>
          <div className="mainDivCreate">
            <div className="titleCreate" style={{ flexDirection: "row" }}>
              <div className="firstTitle" style={{ fontfamily: "Poppins" }}>
                &nbsp;Personal Information &nbsp;
              </div>

              {/* <Button title="Cancel" style={{ flex: '1',display: 'flex', alignItems: 'flex-end'}}/> */}
            </div>

            <input
              onClick
              title="Save Changes"
              className="btn btn-default btn-flat float-right"
              style={{
                display: "flex",
                justifyContent: "right",
                alignItems: "right",
                // background: "#FBEFCB",
                background: "#24B7AA",
                color: "white",
                borderRadius: "6px",
                // padding: "5px 12px",
                marginRight: "32px",
                width: "144px",
                // marginLeft: '6000',
                // padding: '100'
              }}
              defaultValue="Save Changes"
            />

            <input
              onClick
              title="Cancel"
              className="btn btn-default btn-flat float-right"
              style={{
                display: "flex",
                justifyContent: "right",
                alignItems: "right",
                // background: "#FBEFCB",
                borderRadius: "6px",
                // padding: "5px 12px",
                marginRight: "32px",
                width: "82px",
              }}
              defaultValue="Cancel"
            />
            <form
              style={{ marginTop: "58px" }}
              onSubmit={handleSubmit(onSubmit)}
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div style={{ height: "76px" }}>
                    <Box sx={{ m: 1, p: "0 0 5px 0" }}>
                      <InputLabel
                        // htmlFor="paymentLink"
                        className="fontCreate"
                        // required
                        style={{ color: "#547187" }}
                      >
                        Full Name
                      </InputLabel>
                      <Controller
                        name="fullName"
                        control={control}
                        render={({ field }) => (
                          <OutlinedInput
                            {...field}
                            className="textFieldCreate"
                            // id="paymentLink"
                            size="small"
                            // placeholder="Jane Doe"
                            value={fullname}
                            onChange={(e) => setfullname(e.target.value)}
                            aria-describedby="outlined-name-helper-text"
                          />
                        )}
                      />
                      {formState.errors.fullName && (
                        <p
                          className="error"
                          style={{
                            color: "red",
                            fontSize: "10px",
                            marginTop: "2px",
                          }}
                        >
                          <img
                            src="/assets/errorOutline.svg"
                            style={{ height: "12px", width: "12px" }}
                          />{" "}
                          {formState.errors.fullName.message}
                        </p>
                      )}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={6}>
                  <div style={{ height: "76px" }}>
                    <Box sx={{ m: 1, p: "0 0 5px 0" }}>
                      <InputLabel
                        // htmlFor="myRole"
                        className="fontCreate"
                        // required={true}
                        style={{ color: "#547187" }}
                      >
                        My Role
                      </InputLabel>
                      {/* <div style={{ display: "flex", width: "100%" }}> */}
                      {/* <Controller
                          name="currency"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              sx={{
                                width: "84px !important",
                                borderRadius: "4px 0 0 4px",
                              }}
                              defaultValue="INR"
                            >
                              {currency.map((option) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.value}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        /> */}
                      <Controller
                        name="myRole"
                        control={control}
                        render={({ field }) => (
                          <OutlinedInput
                            {...field}
                            className="textFieldCreate"
                            // id="paymentLink"
                            size="small"
                            placeholder="User"
                            aria-describedby="outlined-name-helper-text"
                          />
                        )}
                      />
                      {/* </div> */}
                      {formState.errors.myRole && (
                        <p
                          className="error"
                          style={{
                            color: "red",
                            fontSize: "10px",
                            marginTop: "2px",
                          }}
                        >
                          <img
                            src="/assets/errorOutline.svg"
                            style={{ height: "12px", width: "12px" }}
                          />{" "}
                          {formState.errors.myRole.message}
                        </p>
                      )}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={6}>
                  <div style={{ height: "76px" }}>
                    <Box sx={{ m: 1, p: "0px 0 5px 0" }}>
                      <InputLabel
                        // htmlFor="emailAddress"
                        className="fontCreate"
                        style={{ color: "#547187" }}
                      >
                        Primary Email Address
                      </InputLabel>
                      <Controller
                        name="emailAddress"
                        control={control}
                        render={({ field }) => (
                          <OutlinedInput
                            {...field}
                            className="textFieldCreate"
                            // id="emailAddress"
                            size="small"
                            name="emailAddress"
                            placeholder="jane@gmail.com"
                            aria-describedby="outlined-title-helper-text"
                          />
                        )}
                      />
                      {formState.errors.emailAddress && (
                        <p
                          className="error"
                          style={{
                            color: "red",
                            fontSize: "10px",
                            marginTop: "2px",
                          }}
                        >
                          <img
                            src="/assets/errorOutline.svg"
                            style={{ height: "12px", width: "12px" }}
                          />{" "}
                          {formState.errors.emailAddress.message}
                        </p>
                      )}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={6}>
                  <div style={{ height: "76px" }}>
                    <Box sx={{ m: 1, p: "0 0 5px 0" }}>
                      <InputLabel
                        // htmlFor="mobileNumber"
                        className="fontCreate"
                        // required={true}
                        style={{ color: "#547187" }}
                      >
                        Primary Mobile Number
                      </InputLabel>
                      <Controller
                        name="mobileNumber"
                        control={control}
                        render={({ field }) => (
                          <div
                          // style={{ display: 'flex', flexDirection: 'row' }}
                          >
                            <PhoneInput
                              className="phoneNumber"
                              country={"IN"}
                              enableSearch={true}
                              value={field.value || ""}
                              onCountryChange={(country) => {
                                handleCountryChange(field.value, country);
                                handlePhoneChange(field.value);
                              }}
                              onChange={(value, country) => {
                                field.onChange(value);
                                handlePhoneChange(value);
                              }}
                            />
                            {/*                                                        
                              <InputAdornment position="end">
                                <Button
                                  style={{ 
                                    color: 'blue', 
                                    // alignContent: 'center',
                                    // justifyContent: 'center',
                                    left: '367px',
                                    bottom: '20px',
                                    width: '10px',
                                    textTransform:"none"
                                  }}
                                  // title="Change Password"
                                  onClick
                                >
                                  Verify
                                  </Button>
                              
                              </InputAdornment> */}
                          </div>
                        )}
                      />

                      {formState.errors.mobileNumber && (
                        <p
                          className="error"
                          style={{
                            color: "red",
                            fontSize: "10px",
                            marginTop: "2px",
                          }}
                        >
                          <img
                            src="/assets/errorOutline.svg"
                            style={{ height: "12px", width: "12px" }}
                          />{" "}
                          {formState.errors.mobileNumber.message}
                        </p>
                      )}
                    </Box>
                  </div>
                </Grid>

                <Grid item xs={6}>
                  <div style={{ height: "76px" }}>
                    <Box sx={{ m: 1, p: "0px 0 5px 0" }}>
                      <InputLabel
                        // htmlFor="emailAddress"
                        className="fontCreate"
                        style={{ color: "#547187" }}
                      >
                        Password
                      </InputLabel>
                      {/* <FormControl sx={{ marginTop: "32px", width: "100%" }} required> */}

                      <Controller
                        name="password"
                        control={control}
                        render={({ field }) => (
                          <OutlinedInput
                            {...field}
                            // id="outlined-adornment-password"
                            className="textFieldCreate"
                            // id="emailAddress"
                            // size="small"
                            name="password"
                            placeholder="jane@gmail.com"
                            aria-describedby="outlined-title-helper-text"
                            // placeholder="Password"
                            type={showPassword ? "" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            endAdornment={
                              <InputAdornment position="end">
                                <Button
                                  style={{
                                    color: "blue",
                                    width: "150px",
                                    textTransform: "none",
                                  }}
                                  // title="Change Password"
                                  onClick
                                >
                                  Change Password
                                </Button>
                                {/* <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton> */}
                              </InputAdornment>
                            }
                          />
                        )}
                      />

                      {formState.errors.password && (
                        <p
                          className="error"
                          style={{
                            color: "red",
                            fontSize: "10px",
                            marginTop: "2px",
                          }}
                        >
                          <img
                            src="/assets/errorOutline.svg"
                            style={{ height: "12px", width: "12px" }}
                          />{" "}
                          {formState.errors.password.message}
                        </p>
                      )}
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </form>
          </div>
        </section>
      </div>
    </>
  );
}

export default UserProfile;
